import './CartridgePlayers.css';

function GetLetterA(i, joueur)
{
    switch(i)
    {
        case 0: return "A -";
        case 1: return "B -";
        case 2: return "C -";
        case 3: return "Rpt";
        default: return ""
    }
}

function GetLetterX(i, joueur)
{
    switch(i)
    {
        case 0: return "X -";
        case 1: return "Y -";
        case 2: return "Z -";
        case 3: return "Rpt";
        default: return ""
    }
}

function SpidFlag({countryCode}) {
    if (!countryCode) return null;
    return (
        <img
            className="spid_flag"
            src={process.env.PUBLIC_URL + "/images/atlas_flags/" + countryCode.toLowerCase() + "-flag.jpg"}
            alt={countryCode}
            width="18"
            onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = process.env.PUBLIC_URL + "/images/no-pictures.png";
            }}
        />
    );
}

// "GAUZY Simon N°4- M 9981pts" -> nom "GAUZY Simon" + classement "N°4- M 9981pts"
function SpidName({joueur}) {
    const index = joueur.indexOf(' N°');
    if (index === -1) return <span className="cell_player_name">{joueur}</span>;
    return (
        <>
            <span className="cell_player_name">{joueur.slice(0, index)}</span>
            {' '}
            <span className="cell_player_rank">{joueur.slice(index + 1)}</span>
        </>
    );
}

const CartridgePlayers = ({id, liveTeamA, liveTeamX, countryCodesA, countryCodesX, isFromSPID = false}) => {
    return(
        <div id={"c-" + id} className='players_content'>
            <table className='player' border={0}>
                <tbody>
                {
                    liveTeamA?.map((joueur, i) => {
                        if(isFromSPID && joueur !== undefined && joueur !== null )
                            {
                                if(joueur.trim().length !== 0)
                                {
                                    return(
                                        <tr key={'k' + i}>
                                            <td className='cell_player spid'>
                                                <span className='letter'>{GetLetterA(i, joueur).replace(' -', '')}</span>{GetLetterA(i, joueur).endsWith(' -') && <span className='letter_sep'> -</span>}{' '}
                                                <SpidFlag countryCode={countryCodesA?.[i]} />
                                                <SpidName joueur={joueur} />
                                            </td>
                                        </tr>
                                    )
                                }
                            }
                            else if (joueur !== undefined && joueur !== null )
                            {
                                return ( 
                                    <tr key={'k' + i}><td className='cell_player'>
                                        <img 
                                            src={process.env.PUBLIC_URL + "/images/atlas_flags/" + joueur?.country_code?.toLowerCase()  + "-flag.jpg"} 
                                            alt = {joueur?.country_code}
                                            width="25"
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null; 
                                                currentTarget.src=process.env.PUBLIC_URL + "/images/no-pictures.png";
                                            }}
                                        />
                                        <span style={{paddingLeft: '10px', fontWeight: 'normal'}}>
                                            {joueur?.prenom?.charAt(0)?.toUpperCase() + joueur?.prenom?.slice(1)?.toLowerCase()} {joueur?.nom} {joueur?.classement}
                                        </span>
                                    </td></tr>
                                )
                            }
                            return null;
                    })
                }
                </tbody>
            </table>
            <table className='player'>
                <tbody>
                {
                    liveTeamX?.map((joueur, i) => {
                        if(isFromSPID && joueur !== undefined && joueur !== null && joueur.length > 0)
                            {
                                if(joueur.trim().length !== 0)
                                {
                                    return(
                                        <tr key={'k' + i}>
                                            <td className='cell_player spid'>
                                                <span className='letter'>{GetLetterX(i, joueur).replace(' -', '')}</span>{GetLetterX(i, joueur).endsWith(' -') && <span className='letter_sep'> -</span>}{' '}
                                                <SpidFlag countryCode={countryCodesX?.[i]} />
                                                <SpidName joueur={joueur} />
                                            </td>
                                        </tr>
                                    )
                                }
                            }
                            else if (joueur !== undefined && joueur !== null )
                            {
                                return ( 
                                    <tr key={'k' + i}><td className='cell_player'>
                                        <img 
                                            src={process.env.PUBLIC_URL + "/images/atlas_flags/" + joueur?.country_code?.toLowerCase() + "-flag.jpg"} 
                                            alt = {joueur?.country_code}
                                            width="25"
                                            onError={({ currentTarget }) => {
                                                currentTarget.onerror = null; 
                                                currentTarget.src=process.env.PUBLIC_URL + "/images/no-pictures.png";
                                            }}
                                        />
                                        <span style={{paddingLeft: '10px', fontWeight: 'normal'}}>
                                            {joueur?.prenom?.charAt(0)?.toUpperCase() + joueur?.prenom?.slice(1)?.toLowerCase()} {joueur?.nom} {joueur?.classement}
                                        </span>
                                    </td></tr>
                                )
                            }
                            return null;
                    })
                }
                </tbody>
            </table>
        </div>
    )
}
export default CartridgePlayers;